// extracted by mini-css-extract-plugin
export default {"container":"FrequencySelectorWithConfig_container__QrHT+"};